module.exports = __webpack_public_path__ + "static/media/icon-radio-grey-outline.3dc1da14.svg";